'use client';

import React from 'react';
import dynamic from 'next/dynamic';

// Static Imports (Above the Fold / Critical LCP)
import { HeroParkEuropa } from '@/components/sections/park-europa/HeroParkEuropa';
import { GreenBannerParkEuropa } from '@/components/sections/park-europa/GreenBannerParkEuropa';

// Dynamic Imports (Below the Fold - SSR: false for max mobile speed per user request)
const LocationParkEuropa = dynamic(() => import('@/components/sections/park-europa/LocationParkEuropa').then(mod => mod.LocationParkEuropa), { ssr: false });
const ApartmentFeaturesParkEuropa = dynamic(() => import('@/components/sections/park-europa/ApartmentFeaturesParkEuropa').then(mod => mod.ApartmentFeaturesParkEuropa), { ssr: false });
const AmenitiesParkEuropa = dynamic(() => import('@/components/sections/park-europa/AmenitiesParkEuropa').then(mod => mod.AmenitiesParkEuropa), { ssr: false });
const LifestyleParkEuropa = dynamic(() => import('@/components/sections/park-europa/LifestyleParkEuropa').then(mod => mod.LifestyleParkEuropa), { ssr: false });
const FloorPlansParkEuropa = dynamic(() => import('@/components/sections/park-europa/FloorPlansParkEuropa').then(mod => mod.FloorPlansParkEuropa), { ssr: false });
const SurroundingsMapParkEuropa = dynamic(() => import('@/components/sections/park-europa/SurroundingsMapParkEuropa').then(mod => mod.SurroundingsMapParkEuropa), { ssr: false });

const LeisureAreaPlanParkEuropa = dynamic(() => import('@/components/sections/park-europa/LeisureAreaPlanParkEuropa').then(mod => mod.LeisureAreaPlanParkEuropa), { ssr: false });
const LeisureAreaShowcaseParkEuropa = dynamic(() => import('@/components/sections/park-europa/LeisureAreaShowcaseParkEuropa').then(mod => mod.LeisureAreaShowcaseParkEuropa), { ssr: false });
const ImplantationPlanParkEuropa = dynamic(() => import('@/components/sections/park-europa/ImplantationPlanParkEuropa').then(mod => mod.ImplantationPlanParkEuropa), { ssr: false });
const ImplantationPlanGardenIIParkEuropa = dynamic(() => import('@/components/sections/park-europa/ImplantationPlanGardenIIParkEuropa').then(mod => mod.ImplantationPlanGardenIIParkEuropa), { ssr: false });
const ImplantationPlanTypeParkEuropa = dynamic(() => import('@/components/sections/park-europa/ImplantationPlanTypeParkEuropa').then(mod => mod.ImplantationPlanTypeParkEuropa), { ssr: false });
const FamilySectionParkEuropa = dynamic(() => import('@/components/sections/park-europa/FamilySectionParkEuropa').then(mod => mod.FamilySectionParkEuropa), { ssr: false });
const BuildingFacadeParkEuropa = dynamic(() => import('@/components/sections/park-europa/BuildingFacadeParkEuropa').then(mod => mod.BuildingFacadeParkEuropa), { ssr: false });
const TargetAudienceParkEuropa = dynamic(() => import('@/components/sections/park-europa/TargetAudienceParkEuropa').then(mod => mod.TargetAudienceParkEuropa), { ssr: false });

const ValuesParkEuropa = dynamic(() => import('@/components/sections/park-europa/ValuesParkEuropa').then(mod => mod.ValuesParkEuropa), { ssr: false });
const VideoSection = dynamic(() => import('@/components/sections/VideoSection'), { ssr: false }); // Default export
const Footer = dynamic(() => import('@/components/Footer'), { ssr: false }); // Default export

export default function ParkEuropaCrossfade() {
    return (
        <div className="relative w-full flex flex-col bg-white pt-[90px] overflow-x-hidden font-sans">
            
            <section className="relative w-full">
               <HeroParkEuropa />
            </section>

          
            <section className="relative w-full">
                <GreenBannerParkEuropa />
            </section>

            
            <section className="relative w-full">
                <LocationParkEuropa />
            </section>

           
             <section className="relative w-full">
                <SurroundingsMapParkEuropa />
            </section> 
 
            <section className="relative w-full">
                <ApartmentFeaturesParkEuropa />
            </section>

            <section className="relative w-full">
                <AmenitiesParkEuropa />
            </section>

          
            <section className="relative w-full">
                <LifestyleParkEuropa />
            </section>

            {/* Floorplans Section */}
            <section className="relative w-full">
                <FloorPlansParkEuropa />
            </section>

            {/* Leisure Area Showcase Section (New - Pool Background) */}
            <section className="relative w-full">
                <LeisureAreaShowcaseParkEuropa />
            </section>

            {/* Leisure Area Plan Section (New) */}
            <section className="relative w-full">
                <LeisureAreaPlanParkEuropa />
            </section>

            {/* Implantation Plan Section (New - Garden Floor Plan) */}
            <section className="relative w-full">
                <ImplantationPlanParkEuropa />
            </section>

            {/* Implantation Plan Garden II Section (New - Torre Siena) */}
            <section className="relative w-full">
                <ImplantationPlanGardenIIParkEuropa />
            </section>

            {/* Implantation Plan Type Section (New - Pavimento Tipo) */}
            <section className="relative w-full">
                <ImplantationPlanTypeParkEuropa />
            </section>

            {/* Target Audience (Video) Section (New) */}
            <section className="relative w-full">
                <TargetAudienceParkEuropa />
            </section>

            {/* Facade/Values Section (New) */}
            <section className="relative w-full">
                <BuildingFacadeParkEuropa />
            </section>

            {/* Family Section (New) */}
            <section className="relative w-full">
                <FamilySectionParkEuropa />
            </section>

            {/* Values/Intro Section (Formerly CTA) */}
            <section className="relative w-full">
                <ValuesParkEuropa />
            </section>

            {/* Video Section */}
            <section className="relative w-full">
                <VideoSection />
            </section>

            {/* Footer */}
            <section className="relative w-full">
                <Footer />
            </section>
        </div>
    );
}
